/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Gauge3Icon = ({ width = 24, height = 24, hidden = false, title = 'Gauge3' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.861 4.763a.867.867 0 0 0-1.722 0l-2.31 19.116A3.219 3.219 0 0 0 18 27.649a3.219 3.219 0 0 0 3.171-3.77ZM33.965 18.754A16.163 16.163 0 0 0 21.816 4.292c.006.037.019.071.023.109l.377 3.116A13.022 13.022 0 0 1 31 19.813a12.878 12.878 0 0 1-.691 4.117.492.492 0 0 0 .116.506L31.987 26a.5.5 0 0 0 .818-.154 15.842 15.842 0 0 0 1.16-7.092ZM2 19.813a13.828 13.828 0 0 0 1.394 5.867.5.5 0 0 0 .806.133l1.375-1.376a.491.491 0 0 0 .116-.508 12.465 12.465 0 0 1-.313-7.12 13.334 13.334 0 0 1 8.4-9.227L14.16 4.4c0-.039.019-.074.024-.113A15.993 15.993 0 0 0 2 19.813Z"
    />
  </svg>`;
};
